import fetch from 'node-fetch';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';

const createProfile = async (business: BusinessModel) => {
  const path = `${process.env.NEXT_PUBLIC_ADMIN_API_URL}/businesses/social/profile/fromReservedIdToken?fields=name,timezone,enabled,created`;
  // @ts-ignore WRONG!
  const headers = new fetch.Headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Api-Version': '1.0.10',
    'X-Sdk-Name': 'partner-intake',
    'X-Sdk-Version': '4.91.1',
  });
  const body = {
    name: business.name,
    timezone: 'America/Vancouver',
    token: business.token,
  };

  const response = await fetch(
    path,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    },
  );

  const json = await response.json();

  if (!response.ok) {
    const e = new Error(`${response.status} ${response.statusText}`);
    // @ts-ignore WRONG!
    e.response = response;
    // @ts-ignore I think you'll find `cause` _does_ exist on Error
    e.cause = json;
    throw e;
  }

  return json.payload;
};

export default createProfile;
